// import React, { useState, useMemo, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchOpStrategiesDataRequest } from '../../../redux/api/apiSlice';
// import { 
//   ArrowBack, 
//   Room, 
//   ExpandMore,
//   ExpandLess,
//   FilterList,
//   WbSunny,
//   Terrain,
//   CheckCircle,
//   LocalFireDepartment,
//   Opacity,
//   Cloud,
//   LocationCity
// } from '@mui/icons-material';
// import styles from './OperationalStrategyDetailPage.module.css';

// const HAZARDS = [
//   { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
//   { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
//   { name: 'Earthquakes', icon: <Room className={styles.hazardIcon} /> },
//   { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
//   { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
//   { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
//   { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
// ];

// const OperationalStrategyDetailPage = () => {
//   const { id, section } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { op_strategiesData, loading, error } = useSelector((state) => state.api);
//   const [activeSection, setActiveSection] = useState('');
//   const [expandedImplementations, setExpandedImplementations] = useState({});
//   const [expandedChallenges, setExpandedChallenges] = useState({});
//   const [expandedSubsections, setExpandedSubsections] = useState({});
//   const [selectedHazards, setSelectedHazards] = useState([]);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [expandedLabs, setExpandedLabs] = useState({});

//   useEffect(() => {
//     dispatch(fetchOpStrategiesDataRequest());
//   }, [dispatch]);

//   // Find the strategy
//   const strategy = op_strategiesData?.data?.subcategory?.find((s) => 
//     s.name.toLowerCase().replace(/\s+/g, '-') === id
//   );

//   // Set active section based on URL param or default to first section
//   useEffect(() => {
//     if (strategy?.sections?.length) {
//       const sectionTitles = strategy.sections.map(s => s.title.toLowerCase().replace(/\s+/g, '-'));
//       if (section && sectionTitles.includes(section)) {
//         setActiveSection(strategy.sections[sectionTitles.indexOf(section)].title);
//       } else {
//         setActiveSection(strategy.sections[0].title);
//       }
//     }
//   }, [strategy, section]);

//   // When a tab is clicked, update the URL and active section
//   const handleTabClick = (title) => {
//     const slug = title.toLowerCase().replace(/\s+/g, '-');
//     setActiveSection(title);
//     navigate(`/solutions/operational/${id}/${slug}`);
//   };

//   const toggleHazard = (hazard) => {
//     setSelectedHazards(prev => 
//       prev.includes(hazard)
//         ? prev.filter(h => h !== hazard)
//         : [...prev, hazard]
//     );
//   };

//   // Helper: does a string or hazards array match selected hazards?
//   const matchesHazard = (item) => {
//     if (!selectedHazards.length) return true;
//     if (!item) return false;

//     // Check if item has hazards array
//     if (Array.isArray(item.hazards) && item.hazards.length > 0) {
//       return item.hazards.some(h => selectedHazards.includes(h));
//     }

//     return false;
//   };

//   // Main filterContent function with clarified logic
//   const filterContent = (content) => {
//     if (!selectedHazards.length) return content;

//     // If content is a section object
//     if (typeof content === 'object' && content !== null && !Array.isArray(content)) {
//       // Check if section text matches
//       const sectionTextMatches = matchesHazard(content);
//       // Check if any subsection text matches
//       let subsectionTextMatches = false;
//       if (Array.isArray(content.subsections)) {
//         subsectionTextMatches = content.subsections.some(sub => matchesHazard(sub));
//       }
//       // If section or any subsection text matches, show the entire section (all content)
//       if (sectionTextMatches || subsectionTextMatches) {
//         return content;
//       }
//       // Otherwise, check for labs/objectives in subsections
//       if (Array.isArray(content.subsections)) {
//         // For each subsection, check if any lab matches
//         const filteredSubsections = content.subsections.map(sub => {
//           // If subsection text matches, show all
//           if (matchesHazard(sub)) return sub;
//           // If labs/objectives present, filter them
//           if (Array.isArray(sub.objectives)) {
//             const filteredObjectives = sub.objectives.filter(obj => matchesHazard(obj));
//             if (filteredObjectives.length > 0) {
//               return {
//                 ...sub,
//                 objectives: filteredObjectives
//               };
//             }
//           }
//           return null;
//         }).filter(Boolean);
//         if (filteredSubsections.length > 0) {
//           return {
//             ...content,
//             subsections: filteredSubsections,
//             // Remove objectives at section level if present and not matching (for clarity)
//             ...(content.objectives ? {objectives: undefined} : {})
//           };
//         }
//       }
//       // If labs/objectives at section level (not in subsections)
//       if (Array.isArray(content.objectives)) {
//         const filteredObjectives = content.objectives.filter(obj => matchesHazard(obj));
//         if (filteredObjectives.length > 0) {
//           return {
//             ...content,
//             objectives: filteredObjectives
//           };
//         }
//       }
//       // If nothing matches, return empty object
//       return {};
//     }

//     // If content is an array (e.g. labs/implementations): only show array if any item matches
//     if (Array.isArray(content)) {
//       const filteredArr = content.filter(item => matchesHazard(item));
//       return filteredArr.length > 0 ? filteredArr : [];
//     }

//     // If content is a string: match by text
//     if (typeof content === 'string') {
//       return selectedHazards.some(hazard =>
//         content.toLowerCase().includes(hazard.toLowerCase())
//       ) ? content : null;
//     }

//     return content;
//   };

//   const toggleImplementationExpansion = (index) => {
//     setExpandedImplementations(prev => ({
//       ...prev,
//       [index]: !prev[index]
//     }));
//   };

//   const toggleChallengesExpansion = (index) => {
//     setExpandedChallenges(prev => ({
//       ...prev,
//       [index]: !prev[index]
//     }));
//   };

//   const toggleSubsectionExpansion = (idx) => {
//     setExpandedSubsections(prev => ({
//       ...prev,
//       [idx]: !prev[idx]
//     }));
//   };

//   const toggleLabExpansion = (subIdx, objIdx) => {
//     setExpandedLabs(prev => ({
//       ...prev,
//       [`${subIdx}-${objIdx}`]: !prev[`${subIdx}-${objIdx}`]
//     }));
//   };

//   // Select All logic
//   const allSelected = selectedHazards.length === HAZARDS.length;
//   const toggleSelectAll = () => {
//     setSelectedHazards(allSelected ? [] : HAZARDS.map(h => h.name));
//   };

//   if (loading) {
//     return <div className={styles.mainContainer}>Loading...</div>;
//   }

//   if (error) {
//     return <div className={styles.mainContainer}>Error: {error}</div>;
//   }

//   if (!op_strategiesData?.data?.subcategory) {
//     return <div className={styles.mainContainer}>No strategy data available</div>;
//   }

//   if (!strategy) {
//     return <div className={styles.mainContainer}>Strategy not found</div>;
//   }

//   // Filter the strategy sections based on selected hazards
//   const filteredStrategy = {
//     ...strategy,
//     sections: strategy.sections.map(section => ({
//       ...section,
//       content: filterContent(section.content)
//     })).filter(section => {
//       // Remove sections with empty content after filtering
//       if (typeof section.content === 'string') return section.content !== null;
//       if (Array.isArray(section.content)) return section.content.length > 0;
//       if (typeof section.content === 'object') return Object.keys(section.content).length > 0;
//       return true;
//     })
//   };

//   return (
//     <div className={styles.mainContainer}>
//       <button className={styles.backButton} onClick={() => navigate('/solutions/operational')}>
//         <ArrowBack />
//         Back to Operational Strategies
//       </button>

//       <div className={styles.headerPaper}>
//         <h1 className={styles.mainTitle}>{strategy.name}</h1>
//         <p className={styles.summary}>{strategy.summary}</p>
//       </div>

//       {/* Collapsible Hazard Filter Card */}
//       <div className={styles.collapsibleCard}>
//         <div className={styles.collapsibleHeader} onClick={() => setFilterOpen(o => !o)}>
//           <div className={styles.collapsibleTitle}>
//             <FilterList className={styles.collapsibleIcon} />
//             Filter by Hazards
//           </div>
//           {filterOpen ? (
//             <ExpandLess className={`${styles.collapseArrow} open`} />
//           ) : (
//             <ExpandMore className={styles.collapseArrow} />
//           )}
//         </div>
//         {filterOpen && (
//           <div className={styles.filterContent}>
//             <div className={styles.hazardList}>
//               <div className={styles.selectAllRow}>
//                 <input
//                   type="checkbox"
//                   className={styles.hazardCheckbox}
//                   checked={allSelected}
//                   onChange={toggleSelectAll}
//                   id="selectAllHazards"
//                 />
//                 <label htmlFor="selectAllHazards" className={styles.hazardLabel}>
//                   Select All Hazards
//                 </label>
//               </div>
//               {HAZARDS.map(hazard => (
//                 <div className={styles.hazardRow} key={hazard.name}>
//                   <input
//                     type="checkbox"
//                     className={styles.hazardCheckbox}
//                     checked={selectedHazards.includes(hazard.name)}
//                     onChange={() => toggleHazard(hazard.name)}
//                     id={`hazard-${hazard.name}`}
//                   />
//                   {hazard.icon}
//                   <label htmlFor={`hazard-${hazard.name}`} className={styles.hazardLabel}>
//                     {hazard.name}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className={styles.navigationContainer}>
//         {filteredStrategy.sections.map((section, index) => (
//           <button 
//             key={index}
//             className={`${styles.navButton} ${activeSection === section.title ? styles.active : ''}`}
//             onClick={() => handleTabClick(section.title)}
//           >
//             {section.title}
//           </button>
//         ))}
//       </div>

//       <div className={styles.contentSection}>
//         {filteredStrategy.sections.map((section, sectionIndex) => (
//           activeSection === section.title && (
//             <div key={sectionIndex} className={styles.card}>
//               <h2 className={styles.mainSectionTitle}>{section.title}</h2>
//               <div className={styles.cardContent}>
//                 {/* Section text */}
//                 {section.content && section.content.text && (
//                   <div dangerouslySetInnerHTML={{ 
//                     __html: section.content.text
//                       .replace(/•/g, '</li><li>')
//                       .replace(/([^>])\n/g, '$1</p><p>')
//                       .replace(/^/, '<p>')
//                       .replace(/$/, '</p>')
//                       .replace(/<li>/, '<ul><li>')
//                       .replace(/li>([^<])/g, 'li></ul>$1') 
//                   }} />
//                 )}

//                 {/* Debug: log section content and subsections */}
//                 {console.log('Section content:', section.content)}
//                 {console.log('Section subsections:', section.content && section.content.subsections)}

//                 {/* Subsections (robust) */}
//                 {section.content && section.content.subsections && (
//                       <div className={styles.subsectionsContainer}>
//                     {(Array.isArray(section.content.subsections) ? section.content.subsections : [section.content.subsections]).map((subsection, idx) => (
//                           <div key={idx} className={styles.subsection}>
//                         {/* Subsection title (render if not empty) */}
//                         {subsection.title && (
//                           <div className={styles.subsectionHeader} onClick={() => toggleSubsectionExpansion(idx)}>
//                               <h3 className={styles.subsectionTitle}>{subsection.title}</h3>
//                               {expandedSubsections[idx] ? (
//                                 <ExpandLess className={styles.expandIcon} />
//                               ) : (
//                                 <ExpandMore className={styles.expandIcon} />
//                               )}
//                             </div>
//                         )}
//                         {/* Always render content if text or objectives exist, even if title is empty */}
//                         {(subsection.text || (Array.isArray(subsection.objectives) && subsection.objectives.length > 0)) && expandedSubsections[idx] !== false && (
//                               <div className={styles.subsectionContent}>
//                             {/* Subsection text */}
//                                 {subsection.text && (
//                                   <div dangerouslySetInnerHTML={{ 
//                                     __html: subsection.text
//                                       .replace(/•/g, '</li><li>')
//                                       .replace(/([^>])\n/g, '$1</p><p>')
//                                       .replace(/^/, '<p>')
//                                       .replace(/$/, '</p>')
//                                       .replace(/<li>/, '<ul><li>')
//                                       .replace(/li>([^<])/g, 'li></ul>$1') 
//                                   }} />
//                                 )}
//                             {/* Objectives */}
//                             {Array.isArray(subsection.objectives) && subsection.objectives.length > 0 && (
//                                   <div className={styles.objectivesContainer}>
//                                     {subsection.objectives.map((objective, objIdx) => (
//                                       <div key={objIdx} className={styles.objectiveCard}>
//                                         {objective.lab ? (
//                                           <h4 className={styles.objectiveTitle} style={{cursor: 'pointer'}} onClick={() => toggleLabExpansion(idx, objIdx)}>
//                                             <Room className={styles.locationIcon} />
//                                             {objective.lab}
//                                             {expandedLabs[`${idx}-${objIdx}`] ? (
//                                               <ExpandLess className={styles.expandIcon} />
//                                             ) : (
//                                               <ExpandMore className={styles.expandIcon} />
//                                             )}
//                                           </h4>
//                                         ) : (
//                                           <h4 className={styles.objectiveTitle}>
//                                             <CheckCircle className={styles.optionIcon} />
//                                             {objective.option}
//                                           </h4>
//                                         )}
//                                         {(!objective.lab || expandedLabs[`${idx}-${objIdx}`]) && (
//                                           <p className={styles.objectiveDescription}>{objective.description}</p>
//                                         )}
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                 )}
//               </div>
//             </div>
//           )
//         ))}
//       </div>
//     </div>
//   );
// };

// export default OperationalStrategyDetailPage; 



import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOpStrategiesDataRequest } from '../../../redux/api/apiSlice';
import {
  ArrowBack,
  ExpandMore,
  ExpandLess,
  FilterList,
  WbSunny,
  Terrain,
  Room,
  LocalFireDepartment,
  Opacity,
  Cloud,
  LocationCity,
  CheckCircle
} from '@mui/icons-material';
import styles from './OperationalStrategyDetailPage.module.css';
import { useTranslation } from "react-i18next";
import { Typography } from '@mui/material';

const HAZARDS = [
  { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
  { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
  { name: 'Earthquakes', icon: <Room className={styles.hazardIcon} /> },
  { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
  { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
  { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
  { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
];

const OperationalStrategyDetailPage = () => {
  const { slug, section } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { op_strategiesData, loading, error } = useSelector((state) => state.api);
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  const [activeSection, setActiveSection] = useState('');
  const [expandedObjectives, setExpandedObjectives] = useState({});
  const [selectedHazards, setSelectedHazards] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);

  const [expandedCore, setExpandedCore] = useState(null);

  const toggleCore = (key) => {
    setExpandedCore(expandedCore === key ? null : key);
  };

  const PHASE_TITLE_SECTIONS = [
    "overview-of-naturtejo-geopark-core-lab-needs",
    "overview-of-karsiyaka-municipality-core-lab-needs",
    "overview-of-crete-core-lab-needs",
    "overview-of-famenne-ardenne-geopark-core-labs-needs"
  ];

  const PHASE_TITLES = {
    0: t("solutions.operational.obj-title.title-before"),
    2: t("solutions.operational.obj-title.title-during"),
    4: t("solutions.operational.obj-title.title-after")
  };

  //hardcoded texts for these keys 
  const VR_SIMULATION_KEY =
    "reactions-to-disaster-exposition-through-virtual-reality-simulation";
  const PDI_RESILIANCE_KEY =
    "psychological-post-disaster-impacts-and-resilience";
  const TRONDHEIM_CORE_LAB =
    "overview-of-trondheim-core-lab-needs";

  useEffect(() => {
    if (!slug) return;
    dispatch(fetchOpStrategiesDataRequest({ lang, slug }));
  }, [dispatch, lang, slug]);

  const strategy = op_strategiesData?.data?.subcategory?.find(
    s => s.slug === slug
  );

  useEffect(() => {
    if (!strategy?.sections?.length) return;
    const keys = strategy.sections.map(s => s.key);
    setActiveSection(section && keys.includes(section) ? section : keys[0]);
  }, [strategy, section]);

  const handleTabClick = (key) => {
    setActiveSection(key);
    navigate(`/solutions/operational/${slug}/${key}`);
  };

  const toggleObjective = (key) => {
    setExpandedObjectives(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const objectiveMatchesHazard = (obj) => {
    if (!selectedHazards.length) return true;

    return Array.isArray(obj.hazards) &&
      obj.hazards.some(h => selectedHazards.includes(h));
  };

  if (loading) return <div className={styles.mainContainer}>Loading...</div>;
  if (error) return <div className={styles.mainContainer}>Error: {error}</div>;
  if (!strategy) return <div className={styles.mainContainer}>Strategy not found</div>;

  const sectionsByKey = strategy.sections.reduce((acc, s) => {
    acc[s.key] = s;
    return acc;
  }, {});

  const activeSectionObj = sectionsByKey[activeSection];
  const subsections = activeSectionObj?.content?.subsections || [];

  return (
    <div className={styles.mainContainer}>
      <button
        className={styles.backButton}
        onClick={() => navigate('/solutions/operational')}
      >
        <ArrowBack />
        {t("solutions.navigation.backToPages.operational")}
      </button>

      <div className={styles.headerPaper}>
        <Typography variant="h6" className={styles.mainTitle}>
          {strategy.name}
        </Typography>
        <Typography variant="body1" className={styles.summary}>
          {strategy.summary}
        </Typography>
      </div>

      <div className={styles.collapsibleCard}>
        <div
          className={styles.collapsibleHeader}
          onClick={() => setFilterOpen(o => !o)}
        >
          <div className={styles.collapsibleTitle}>
            <FilterList className={styles.collapsibleIcon} />
            <Typography variant="subtitle1" className={styles.collapsibleTitle}>
              Filter by Hazards
            </Typography>
          </div>
          {filterOpen ? <ExpandLess /> : <ExpandMore />}
        </div>

        {filterOpen && (
          <div className={styles.filterContent}>
            {HAZARDS.map(h => (
              <div key={h.name} className={styles.hazardRow}>
                <input
                  type="checkbox"
                  checked={selectedHazards.includes(h.name)}
                  onChange={() =>
                    setSelectedHazards(prev =>
                      prev.includes(h.name)
                        ? prev.filter(x => x !== h.name)
                        : [...prev, h.name]
                    )
                  }
                />
                {h.icon}
                <Typography variant="subtitle1">{h.name}</Typography>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.navigationContainer}>
        {strategy.sections.map(s => (
          <button
            key={s.key}
            className={`${styles.navButton} ${activeSection === s.key ? styles.active : ''
              }`}
            onClick={() => handleTabClick(s.key)}
          >
            <Typography variant="body1">
              {s.title}
            </Typography>
          </button>
        ))}
      </div>

      <div className={styles.card}>
        <Typography variant="h6" className={styles.mainSectionTitle}>
          {activeSectionObj?.title}
        </Typography>

        <div className={styles.cardContent}>

          {/* added hardcoded text because i commented out the text from the database 
          and these sections were empty without this */}
          {activeSection === VR_SIMULATION_KEY && (
            <>
              <Typography variant="h6" className={styles.sectionText}>
                {t("solutions.operational.key.title-trondheim")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-trondheim")}
              </Typography>

              <Typography variant="h6" className={styles.sectionText} sx={{ mt: 4 }}>
                {t("solutions.operational.key.title-famenne")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-famenne")}
              </Typography>
            </>
          )}



          {activeSection === PDI_RESILIANCE_KEY && (
            <>
              <Typography variant="h6" className={styles.sectionText}>
                {t("solutions.operational.key.title-risk")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-risk")}
              </Typography>

              <Typography variant="h6" className={styles.sectionText} sx={{ mt: 4 }}>
                {t("solutions.operational.key.title-ptsd")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-ptsd")}
              </Typography>

              <Typography variant="h6" className={styles.sectionText}>
                {t("solutions.operational.key.title-trust")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-trust")}
              </Typography>

              <Typography variant="h6" className={styles.sectionText} sx={{ mt: 4 }}>
                {t("solutions.operational.key.title-results")}
              </Typography>

              <Typography variant="body1" className={styles.sectionText}>
                {t("solutions.operational.key.description-results")}
              </Typography>
            </>
          )}



          {activeSectionObj?.content?.text && (
            <Typography
              variant="body1"
              className={styles.richText}
            >
              {activeSectionObj.content.text}
            </Typography>
          )}



          <div className={styles.analysisSection}>
            {subsections.map((sub, idx) => (
              <div key={idx}>

                {/* HARD CODED PHASE TITLE */}
                {PHASE_TITLE_SECTIONS.includes(activeSection) && PHASE_TITLES[idx] && (
                  <Typography
                    variant="h6"
                    className={styles.phaseTitle}
                  >
                    {PHASE_TITLES[idx]}
                  </Typography>
                )}

                {sub.objectives
                  ?.filter(objectiveMatchesHazard)
                  .map((o, i) => {
                    const key = `${idx}-${i}`;

                    return (
                      <div key={key} className={styles.labCard}>
                        <div
                          className={styles.labHeader}
                          onClick={() => toggleObjective(key)}
                        >
                          <div className={styles.labHeaderContent}>
                            <CheckCircle className={styles.locationIcon} />

                            <Typography
                              variant="h6"
                              className={styles.labTitle}
                            >
                              {o.lab || o.option}
                            </Typography>
                          </div>

                          {expandedObjectives[key]
                            ? <ExpandLess className={styles.expandIcon} />
                            : <ExpandMore className={styles.expandIcon} />
                          }
                        </div>

                        {expandedObjectives[key] && (
                          <div className={styles.labContent}>
                            {o.description && (
                              <Typography
                                variant="body1"
                                className={styles.objectiveDescription}
                              >
                                {o.description}
                              </Typography>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>

          {activeSection === TRONDHEIM_CORE_LAB && (
            <div className={styles.analysisSection}>

              {/* BEFORE */}
              <div className={styles.labCard}>
                <div
                  className={styles.labHeader}
                  onClick={() => toggleCore("before")}
                >
                  <div className={styles.labHeaderContent}>
                    <CheckCircle className={styles.locationIcon} />

                    <Typography variant="h6" className={styles.labTitle}>
                      {t("solutions.operational.obj-title.title-before")}
                    </Typography>
                  </div>

                  {expandedCore === "before"
                    ? <ExpandLess className={styles.expandIcon} />
                    : <ExpandMore className={styles.expandIcon} />
                  }
                </div>

                {expandedCore === "before" && (
                  <div className={styles.labContent}>
                    <Typography variant="body1" className={styles.objectiveDescription}>
                      {t("solutions.operational.key-trondheim-core.text-before")}
                    </Typography>
                  </div>
                )}
              </div>


              {/* DURING */}
              <div className={styles.labCard}>
                <div
                  className={styles.labHeader}
                  onClick={() => toggleCore("during")}
                >
                  <div className={styles.labHeaderContent}>
                    <CheckCircle className={styles.locationIcon} />

                    <Typography variant="h6" className={styles.labTitle}>
                      {t("solutions.operational.obj-title.title-during")}
                    </Typography>
                  </div>

                  {expandedCore === "during"
                    ? <ExpandLess className={styles.expandIcon} />
                    : <ExpandMore className={styles.expandIcon} />
                  }
                </div>

                {expandedCore === "during" && (
                  <div className={styles.labContent}>
                    <Typography variant="body1" className={styles.objectiveDescription}>
                      {t("solutions.operational.key-trondheim-core.text-during")}
                    </Typography>
                  </div>
                )}
              </div>


              {/* AFTER */}
              <div className={styles.labCard}>
                <div
                  className={styles.labHeader}
                  onClick={() => toggleCore("after")}
                >
                  <div className={styles.labHeaderContent}>
                    <CheckCircle className={styles.locationIcon} />

                    <Typography variant="h6" className={styles.labTitle}>
                      {t("solutions.operational.obj-title.title-after")}
                    </Typography>
                  </div>

                  {expandedCore === "after"
                    ? <ExpandLess className={styles.expandIcon} />
                    : <ExpandMore className={styles.expandIcon} />
                  }
                </div>

                {expandedCore === "after" && (
                  <div className={styles.labContent}>
                    <Typography variant="body1" className={styles.objectiveDescription}>
                      {t("solutions.operational.key-trondheim-core.text-after")}
                    </Typography>
                  </div>
                )}
              </div>

            </div>
          )}

        </div>
      </div>
    </div >
  );
};

export default OperationalStrategyDetailPage;







